import './App.css';
import { useState, Suspense, useRef, useEffect } from 'react';
import { Canvas, useThree } from '@react-three/fiber';
import { Glasses } from './components/Glasses';
import { FaceRecognition } from './components/FaceRecognition';
import { EffectComposer, SMAA } from '@react-three/postprocessing';

function App() {
  const [url, setUrl] = useState<string>("/assets/Scene.glb");
  const canvasRef = useRef<HTMLCanvasElement>(null);
  function isMobileDevice() {
    return /iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile|Windows Phone/i
        .test(navigator.userAgent);
  }

  const fov = isMobileDevice() ? 50 : 57;
  const handleUrlChange = (newUrl: string) => {
    setUrl(newUrl);
  };

  return (
    <div className="app">
      <div className="glasses-container">
        <div className="video">
         <FaceRecognition/>
        </div>
        <div className="canvas">
          <Canvas
            ref={canvasRef}
            dpr={window.devicePixelRatio}
            gl={{ antialias: true }}
            camera={{ fov: fov, position:[0, 0, 7]}}
          >
            <ambientLight intensity={0.5} />
            <Suspense fallback={null}>
              <EffectComposer multisampling={0}>
                <SMAA />
              </EffectComposer>
            </Suspense>
            <Glasses url={url} />
          </Canvas>
        </div>
      </div>


  </div>
  );
}

export default App;
